import { render, staticRenderFns } from "./MyToDo.vue?vue&type=template&id=1759a272&scoped=true&"
import script from "./MyToDo.ts?vue&type=script&lang=ts&"
export * from "./MyToDo.ts?vue&type=script&lang=ts&"
import style0 from "./MyToDo.vue?vue&type=style&index=0&id=1759a272&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1759a272",
  null
  
)

export default component.exports